var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"badge-container"},[_c('div',{staticClass:"badge-title"},[_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"badge-body"},[_vm._t("default")],2),(_vm.copy)?_c('a-icon',{staticStyle:{"cursor":"pointer"},attrs:{"type":"copy"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }